import React from 'react';
import c from 'classnames';
import { useTranslation } from 'react-i18next';

import { SearchFacetRefinementSelect } from '@uncinc/react-searchkit';

import SearchFacets from '../../Search/Facets';

import './style.scss';

export interface SearchAllProjectsFacetsProps {
  forceDialog?: boolean;
}

const SearchAllProjectsFacets: React.FC<SearchAllProjectsFacetsProps> = (props) => {
  const { t } = useTranslation();

  const { forceDialog = false } = props;

  const classNames = c('SearchAllProjects__Facets', 'mb-8', {
    'SearchAllProjects__Facets--force-dialog': forceDialog,
  });

  return (
    <SearchFacets
      className={classNames}
      forceDialog={forceDialog}
      hideTitle
    >
      <SearchFacetRefinementSelect
        attribute="project_type"
        placeholder={t('components.project_map.filters.project_type_placeholder')}
        showMore
      />

      <SearchFacetRefinementSelect
        attribute="project_status"
        placeholder={t('components.project_map.filters.project_status_placeholder')}
        showMore
      />
    </SearchFacets>
  );
};

export default SearchAllProjectsFacets;
